import { Component } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'liketat-web';
  constructor(
      public authService: AuthService,
      private router: Router
    ){
    
  }

  logout(){
    this.authService.logout()
      .then(
        () => {
          this.router.navigate(['/login']);
        }
      );
  }
}
